// Fork Oito: estado do painel lateral da fila (compartilhado entre rota e layout)
import { ref } from 'vue';

export const funilAberto = ref(false);
